import { render, staticRenderFns } from "./AddEditBankAccountModal.vue?vue&type=template&id=57cb2953&scoped=true"
import script from "./AddEditBankAccountModal.vue?vue&type=script&lang=js"
export * from "./AddEditBankAccountModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditBankAccountModal.vue?vue&type=style&index=0&id=57cb2953&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cb2953",
  null
  
)

export default component.exports